<template>
    <div>
        <div class="autoOpenContent" v-if="generalSettings.autoUnlockTimesEnable === 1">
            <div class="autoOpenTop">
                <div class="panelsItem">
                    <label :title="$t('LockName')">{{$t('LockName')}}</label>
                    <el-select @change="changeLock" v-model="lock" class="editInput" :placeholder="$t('LockName')">
                        <el-option
                        v-for="item in locksOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="panelsItem">
                    <label :title="$t('ModeSelection')">{{$t('ModeSelection')}}</label>
                    <el-select @change="chanegModeSelection"  v-model="unlockMode" class="editInput" :placeholder="$t('ModeSelection')">
                        <el-option
                        v-for="item in unlockModeOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="panelsItem">
                    <label :title="$t('Day')">{{$t('Day')}}</label>
                    <el-select @change="chanegDay"  v-model="day" class="editInput" :placeholder="$t('Day')">
                        <el-option
                        v-for="item in dayOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="autoOpenCenter" v-show="unlockMode === 'momentory'">
                <div class="panelsItem" v-for="(item,index) in momentory.plan" :key="item.id">
                    <label :title="$t('Plan1').replace('1',(index+1))">{{$t('Plan1').replace('1',(index+1))}}</label>
                    <el-time-picker
                    class="timePicker"
                    v-model="item.time"
                    format="HH:mm"
                    value-format="HH:mm"
                    :picker-options="{
                        selectableRange: '00:00:00 - 23:59:59'
                    }"
                    @change="changeMomentoryTime(item,index)"
                    :placeholder="$t('SelectionTime')"
                    :disabled="item.isDisabled"
                    >
                    </el-time-picker>
                </div>
            </div>
            <div class="autoOpenFoot" v-show="unlockMode === 'momentory'">
                <h5>{{$t('DaySelection')}}</h5>
                <div class="dayAll">
                    <el-checkbox v-model="momentory.all" @change="changeMomentoryAll">{{$t('All')}}</el-checkbox>
                </div>
                <div class="dayItemBox">
                    <div class="dayItem">
                        <el-checkbox v-model="momentory.mon" @change="changeMomentoryItem">{{$t('MondayShort')}}</el-checkbox>
                    </div>
                    <div class="dayItem">
                        <el-checkbox v-model="momentory.tue" @change="changeMomentoryItem">{{$t('TuesdayShort')}}</el-checkbox>
                    </div>
                    <div class="dayItem">
                        <el-checkbox v-model="momentory.wed" @change="changeMomentoryItem">{{$t('WednesdayShort')}}</el-checkbox>
                    </div>
                    <div class="dayItem">
                        <el-checkbox v-model="momentory.thu" @change="changeMomentoryItem">{{$t('ThursdayShort')}}</el-checkbox>
                    </div>
                    <div class="dayItem">
                        <el-checkbox v-model="momentory.fri" @change="changeMomentoryItem">{{$t('FridayShort')}}</el-checkbox>
                    </div>
                    <div class="dayItem">
                        <el-checkbox v-model="momentory.sat" @change="changeMomentoryItem">{{$t('SaturdayShort')}}</el-checkbox>
                    </div>
                    <div class="dayItem">
                        <el-checkbox v-model="momentory.sun" @change="changeMomentoryItem">{{$t('SundayShort')}}</el-checkbox>
                    </div>
                </div>
            </div>
            <div class="autoOpenCenter" v-show="unlockMode === 'hold'">
                <div class="panelsItem" v-for="(item,index) in hold.plan" :key="item.id">
                    <label :title="$t('Plan1').replace('1',(index+1))">{{$t('Plan1').replace('1',(index+1))}}</label>
                    <el-time-picker
                    class="timePicker"
                    v-model="item.startTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    :picker-options="{
                        selectableRange: '00:00:00 - 23:59:59',
                        defaultValue: ''
                    }"
                    @change="changeHoldTime(item,index)"
                    :disabled="item.isDisabled"
                    :placeholder="$t('SelectionTime')"                
                    >
                    </el-time-picker>
                    <span> ~~ </span>
                    <el-time-picker
                    class="timePicker"
                    v-model="item.endTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    :picker-options="{
                        selectableRange: '00:00:00 - 23:59:59',
                        defaultValue: ''
                    }"
                    @change="changeHoldTime(item,index)"
                    :disabled="item.isDisabled"
                    :placeholder="$t('SelectionTime')"              
                    >
                    </el-time-picker>
                </div>
            </div>
            <div class="autoOpenFoot" v-show="unlockMode === 'hold'">
                <h5>{{$t('DaySelection')}}</h5>
                <div class="dayAll">
                    <el-checkbox v-model="hold.all" @change="changeHoldAll">{{$t('All')}}</el-checkbox>
                </div>
                <div class="dayItemBox">
                    <div class="dayItem">
                        <el-checkbox v-model="hold.mon" @change="changeHoldItem">{{$t('MondayShort')}}</el-checkbox>
                    </div>
                    <div class="dayItem">
                        <el-checkbox v-model="hold.tue" @change="changeHoldItem">{{$t('TuesdayShort')}}</el-checkbox>
                    </div>
                    <div class="dayItem">
                        <el-checkbox v-model="hold.wed" @change="changeHoldItem">{{$t('WednesdayShort')}}</el-checkbox>
                    </div>
                    <div class="dayItem">
                        <el-checkbox v-model="hold.thu" @change="changeHoldItem">{{$t('ThursdayShort')}}</el-checkbox>
                    </div>
                    <div class="dayItem">
                        <el-checkbox v-model="hold.fri" @change="changeHoldItem">{{$t('FridayShort')}}</el-checkbox>
                    </div>
                    <div class="dayItem">
                        <el-checkbox v-model="hold.sat" @change="changeHoldItem">{{$t('SaturdayShort')}}</el-checkbox>
                    </div>
                    <div class="dayItem">
                        <el-checkbox v-model="hold.sun" @change="changeHoldItem">{{$t('SundayShort')}}</el-checkbox>
                    </div>
                </div>
            </div>
            
            <div class="bottomDiv">
                <el-button class="savetBtn" :loading="this.generalSettings.updateAutoOpenState == 1" @click="applyUpdatePanelsAutoOpen">{{$t('Apply')}}</el-button>
            </div>
        </div>
        <div v-else>
            <h3>{{$t('DeviceNotSupportConfig')}}</h3>
        </div>
    </div>
    
  
</template>

<script>
import { mapState } from 'vuex';
import { debounce } from 'lodash'
import { nanoid } from 'nanoid';
import sitesPanelsApi from '@/api/panels/index.js'
let days = ["mon","tue","wed","thu","fri","sat","sun"];
let daysToVal = ["sun","mon","tue","wed","thu","fri","sat"];
let autoOpenTimeData = {};
export default {
    name:"AutoOpeningTimes",
    data(){
        return{
            generalSettings:{
                autoUnlockTimesEnable:0,
                updateAutoOpenState:0,
            },
            updatePanels:{
                id:"",
            },
            lock:"",
            locksOptions:[],
            //锁的数量
            entranceLockCount:0,
            unlockMode:"momentory",
            unlockModeOptions:[
                {
                    id:"momentory",
                    name:this.$t('MomentaryUnlock')
                },
                {
                    id:"hold",
                    name:this.$t('HoldOpen')
                },
            ],
            day:new Date().getDay().toString(),
            dayOptions:[
                {
                    id:"0",
                    name:this.$t('Sunday')
                },
                {
                    id:"1",
                    name:this.$t('Monday')
                },
                {
                    id:"2",
                    name:this.$t('Tuesday')
                },
                {
                    id:"3",
                    name:this.$t('Wednesday')
                },
                {
                    id:"4",
                    name:this.$t('Thursday')
                },
                {
                    id:"5",
                    name:this.$t('Friday')
                },
                {
                    id:"6",
                    name:this.$t('Saturday')
                },
            ],
            momentory:{
                plan:[
                    {
                        "id":nanoid(),
                        "time":"",
                        "isDisabled":false,
                    },
                    {
                        "id":nanoid(),
                        "time":"",
                        "isDisabled":true,
                    },
                    {
                        "id":nanoid(),
                        "time":"",
                        "isDisabled":true,
                    },
                    {
                        "id":nanoid(),
                        "time":"",
                        "isDisabled":true,
                    },
                    {
                        "id":nanoid(),
                        "time":"",
                        "isDisabled":true,
                    },
                    {
                        "id":nanoid(),
                        "time":"",
                        "isDisabled":true,
                    },
                    
                ],
                all:false,
                mon:false,
                tue:false,
                wed:false,
                thu:false,
                fri:false,
                sat:false,
                sun:false,
            },
            hold:{
                plan:[
                    {
                        "id":nanoid(),
                        "startTime":"",
                        "endTime":"",
                        "isDisabled":false,
                    },
                    {
                        "id":nanoid(),
                        "startTime":"",
                        "endTime":"",
                        "isDisabled":true,
                    },
                    {
                        "id":nanoid(),
                        "startTime":"",
                        "endTime":"",
                        "isDisabled":true,
                    },
                    {
                        "id":nanoid(),
                        "startTime":"",
                        "endTime":"",
                        "isDisabled":true,
                    },
                    {
                        "id":nanoid(),
                        "startTime":"",
                        "endTime":"",
                        "isDisabled":true,
                    },
                    {
                        "id":nanoid(),
                        "startTime":"",
                        "endTime":"",
                        "isDisabled":true,
                    },
                ],
                all:false,
                mon:false,
                tue:false,
                wed:false,
                thu:false,
                fri:false,
                sat:false,
                sun:false,
            }
        }
    },
    mounted(){
    //    console.log("this.$route.params.id",this.$route.params.id);
       this.updatePanels.id = this.$route.params.id; 
       this.initAutoOpenTime();
    //    this.getGeneralShadowConfig();
    //    this.day = new Date().getDay().toString();  
    },
    computed:{
        ...mapState(["selectCompany","selectSite"])
    },
    watch:{
        'momentory.plan.0.time'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.momentory.plan[0].time = "";
                }, 20);
            }    
        },
        'momentory.plan.1.time'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.momentory.plan[1].time = "";
                }, 20);
            }    
        },
        'momentory.plan.2.time'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.momentory.plan[2].time = "";
                }, 20);
            }    
        },
        'momentory.plan.3.time'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.momentory.plan[3].time = "";
                }, 20);
            }    
        },
        'momentory.plan.4.time'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.momentory.plan[4].time = "";
                }, 20);
            }    
        },
        'momentory.plan.5.time'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.momentory.plan[5].time = "";
                }, 20);
            }    
        },
        'hold.plan.0.startTime'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.hold.plan[0].startTime = "";
                }, 20);
            }    
        },
        'hold.plan.0.endTime'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.hold.plan[0].endTime = "";
                }, 20);
            }    
        },
        'hold.plan.1.startTime'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.hold.plan[1].startTime = "";
                }, 20);
            }    
        },
        'hold.plan.1.endTime'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.hold.plan[1].endTime = "";
                }, 20);
            }    
        },
        'hold.plan.2.startTime'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.hold.plan[2].startTime = "";
                }, 20);
            }    
        },
        'hold.plan.2.endTime'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.hold.plan[2].endTime = "";
                }, 20);
            }    
        },
        'hold.plan.3.startTime'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.hold.plan[3].startTime = "";
                }, 20);
            }    
        },
        'hold.plan.3.endTime'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.hold.plan[3].endTime = "";
                }, 20);
            }    
        },
        'hold.plan.4.startTime'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.hold.plan[4].startTime = "";
                }, 20);
            }    
        },
        'hold.plan.4.endTime'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.hold.plan[4].endTime = "";
                }, 20);
            }    
        },
        'hold.plan.5.startTime'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.hold.plan[5].startTime = "";
                }, 20);
            }    
        },
        'hold.plan.5.endTime'(val){
            if(val === '' || val === null){
                setTimeout(() => {
                    this.hold.plan[5].endTime = "";
                }, 20);
            }    
        },
    },
    methods:{
        //lock model days
        initLockModelDays(){
            this.lock = 'lock1';
            this.unlockMode = 'momentory';
            this.day = new Date().getDay().toString();
        },
        //初始化
        initAutoOpenTime(){
            if(this.unlockMode === 'momentory'){
                this.momentory.all = false;
                this.momentory.mon = false;
                this.momentory.tue = false;
                this.momentory.wed = false;
                this.momentory.thu = false;
                this.momentory.fri = false;
                this.momentory.sat = false;
                this.momentory.sun = false;
                //初始化 momentory
                this.momentory.plan.map((item,index) => {
                    item.time = '';
                    if(index === 0){
                        item.isDisabled = false;
                    }else{
                        item.isDisabled = true;
                    }
                })
                switch(this.day){
                    case "0":
                        this.momentory.sun = true
                        break;
                    case "1":
                        this.momentory.mon = true
                        break;
                    case "2":
                        this.momentory.tue = true
                        break;
                    case "3":
                        this.momentory.wed = true
                        break;
                    case "4":
                        this.momentory.thu = true
                        break;
                    case "5":
                        this.momentory.fri = true
                        break;
                    case "6":
                        this.momentory.sat = true
                        break;
                    default:
                        break;
                }
                 
            }else if(this.unlockMode === 'hold'){
                this.hold.all = false;
                this.hold.mon = false;
                this.hold.tue = false;
                this.hold.wed = false;
                this.hold.thu = false;
                this.hold.fri = false;
                this.hold.sat = false;
                this.hold.sun = false;
                //初始化 hold
                this.hold.plan.map((item,index) => {
                    item.startTime = '';
                    item.endTime = '';
                    if(index === 0){
                        item.isDisabled = false;
                    }else{
                        item.isDisabled = true;
                    }
                })
                switch(this.day){
                    case "0":
                        this.hold.sun = true
                        break;
                    case "1":
                        this.hold.mon = true
                        break;
                    case "2":
                        this.hold.tue = true
                        break;
                    case "3":
                        this.hold.wed = true
                        break;
                    case "4":
                        this.hold.thu = true
                        break;
                    case "5":
                        this.hold.fri = true
                        break;
                    case "6":
                        this.hold.sat = true
                        break;
                    default:
                        break;
                }
            }
        },
        //查询Auto Open Time Settings配置
        getGeneralShadowConfig(){
            //先清空，再渲染
            this.momentory.plan.map((item,index) => {
                item.time = '';
                if(index === 0){
                    item.isDisabled = false;
                }else{
                    item.isDisabled = true;
                }
                
            })
            let generalInfoObj = {
                "rgn":this.selectCompany.companyRegion,
                "entranceDeviceId":this.updatePanels.id,
                "siteId":this.selectSite.id,
                "filter":['autoUnlockTimes'].join(','),
            }
            if(!this.updatePanels.id){
                return false
            }
            sitesPanelsApi.getGeneralDeviceShadowConfig(generalInfoObj).then(res => {
                if(res.code === 0){
                //获取是否支持自动开锁时间设置
                this.generalSettings.autoUnlockTimesEnable = res.data.configAbility.autoUnlockTimesEnable;
                this.entranceLockCount = res.data.configAbility.entranceLockCount;
                if(this.entranceLockCount){
                    this.lock = 'lock1';
                    this.locksOptions = [];
                    for(let i = 0;i < this.entranceLockCount;i++){
                        this.locksOptions.push({
                            id:"lock"+(i+1),
                            name:"Lock "+(i+1),
                        })
                    }
                }
                if(res.data.autoUnlockTimes === null || res.data.autoUnlockTimes === undefined){
                    if(this.generalSettings.entranceLockCount){
                        for(let i = 0;i < this.entranceLockCount;i++){
                            autoOpenTimeData["lock"+(i+1)] = {
                                "hold": {},
                                "momentory": {},
                            }
                        }
                    }
                //    autoOpenTimeData = {
                //         "lock1": {
                //             "hold": {},
                //             "momentory": {},
                //         },
                //         "lock2": {
                //             "hold": {},
                //             "momentory": {},
                //         }
                //     };
                }else{
                    autoOpenTimeData = JSON.parse(res.data.autoUnlockTimes);
                }
                //调用lock改变方法，加载数据
                this.changeLock();
                }else{
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        //判断时间段是否合法
        watchTimePeriod(start,end){
            if((start === '' || start === null) && (end === "" || end === null)){
                return true
            }
            if(start === '' || start === null || start === undefined){
                return false
            }
            if(end === '' || end === null || end === undefined){
                return false
            }
            if(start != "" && start != null && end != "" && end != null){
                let startTime = Number(start.split(':')[0]) * 60 * 60 * 800 + Number(start.split(':')[1]) * 60 * 800 
                let endTime = Number(end.split(':')[0]) * 60 * 60 * 800 + Number(end.split(':')[1]) * 60 * 800 
                if(startTime >= endTime){
                    this.$message.info(this.$t('StartTimeLaterEndTime'));
                    return false
                }else{
                    return true
                }
            }
            return true;
        },
        //判断时间段是否合法
        checkTimePeriod(start,end){
            if((start === "" || start === null) && (end === '' || end === null)){
                return true
            }
            if(start === '' || start === null || start === undefined){
                this.$message.info(this.$t('StartTimeEmptye'));
                return false
            }
            if(end === '' || end === null || end === undefined){
                this.$message.info(this.$t('EndTimeEmptye'));
                return false
            }
            if(start != "" && start != null && end != '' && end != null){
                let startTime = Number(start.split(':')[0]) * 60 * 60 * 800 + Number(start.split(':')[1]) * 60 * 800 
                let endTime = Number(end.split(':')[0]) * 60 * 60 * 800 + Number(end.split(':')[1]) * 60 * 800 
                if(startTime >= endTime){
                    this.$message.info(this.$t('StartTimeLaterEndTime'));
                    return false
                }
            }
            
            return true;
        },
        //lock model day切换公共函数
        changeLockModelDays(){
            //判断后端数据是否存在
            // if(autoOpenTimeData === null || autoOpenTimeData === undefined){
            //     return false
            // }
            // if(autoOpenTimeData[this.lock] === null || autoOpenTimeData[this.lock] === undefined){
            //     return false
            // }
            //判断当前选择的lock model是否存在
            // if(!autoOpenTimeData[this.lock][this.unlockMode]){
            //     return
            // }
            //判断当前选择的lock model day是否存在
            if(!autoOpenTimeData[this.lock]){
                return
            }
            if(!autoOpenTimeData[this.lock][this.unlockMode]){
                return
            }
            if(!autoOpenTimeData[this.lock][this.unlockMode][this.day]){
                return
            }
            autoOpenTimeData[this.lock][this.unlockMode][this.day].map((item,index) => {
                if(this.unlockMode === "momentory"){
                    this[this.unlockMode].plan[index].time = item;
                    this[this.unlockMode].plan[index].isDisabled = false;
                    if(autoOpenTimeData[this.lock][this.unlockMode][this.day].length < 6){
                        this[this.unlockMode].plan[autoOpenTimeData[this.lock][this.unlockMode][this.day].length].isDisabled = false;
                    }
                }else{
                    this[this.unlockMode].plan[index].startTime = item.split("-")[0];
                    this[this.unlockMode].plan[index].endTime = item.split("-")[1];
                    this[this.unlockMode].plan[index].isDisabled = false;
                    if(autoOpenTimeData[this.lock][this.unlockMode][this.day].length < 6){
                        this[this.unlockMode].plan[autoOpenTimeData[this.lock][this.unlockMode][this.day].length].isDisabled = false;
                    }
                }
            })
        },
        //change lock
        changeLock(){
            this.initAutoOpenTime();
            this.changeLockModelDays();
        },
        //Mode Selection 改变执行函数
        chanegModeSelection(){
            this.initAutoOpenTime();
            this.changeLockModelDays();
        },
        //chanegDay
        chanegDay(){
            if(this.unlockMode === 'momentory'){
                this.momentory.all = false;
                this.momentory.mon = false;
                this.momentory.tue = false;
                this.momentory.wed = false;
                this.momentory.thu = false;
                this.momentory.fri = false;
                this.momentory.sat = false;
                this.momentory.sun = false;
            }else if(this.unlockMode === 'hold'){
                this.hold.all = false;
                this.hold.mon = false;
                this.hold.tue = false;
                this.hold.wed = false;
                this.hold.thu = false;
                this.hold.fri = false;
                this.hold.sat = false;
                this.hold.sun = false;
            }
            this.initAutoOpenTime();
            this.changeLockModelDays();
        },
        //Momentory时间点改变执行函数
        changeMomentoryTime(item,index){
            if(index < 5){
                if(item.time != "" || item.time != null){
                    this.momentory.plan[(index+1)].isDisabled = false;
                }
            }
            if(item.time === '' || item.time === null){
                this.momentory.plan.splice(index,1)
                this.momentory.plan.push({
                    "id":nanoid(),
                    "time":"",
                    "isDisabled":true,
                })
            }
            //判断最后一个时间段是否要禁用
            if(this.momentory.plan[4].time != ""){
                this.momentory.plan[5].isDisabled = false
            }
        },
        //Momentory模式点击全选
        changeMomentoryAll(val){
            if(val){
                days.map(item => {
                    this.momentory[item] = true;
                })
            }else{
                days.map(item => {
                    this.momentory[item] = false;
                })
                this.initAutoOpenTime();
            }
        },
        changeMomentoryItem(){
            let checkedItemLength = 0;
            days.map(item => {
                if(this.momentory[item] === true){
                    checkedItemLength++
                }
            })
            if(checkedItemLength === 7){
                this.momentory.all = true;
            }else{
                this.momentory.all = false;
            }
        },
        
        //Hold时间点改变执行函数
        changeHoldTime(item,index){
            let isTimePeriodValid = this.watchTimePeriod(item.startTime,item.endTime);
            if(!isTimePeriodValid){
                return false
            }
            if(index < 5){
                if(item.startTime != "" && item.endTime != ""  && !item.isDisabled){
                    this.hold.plan[(index+1)].isDisabled = false;
                }
            }
            
            if((item.startTime === '' || item.startTime === null) && (item.endTime === '' || item.endTime === null)){
                this.hold.plan.splice(index,1)
                this.hold.plan.push({
                    "id":nanoid(),
                    "startTime":"",
                    "endTime":"",
                    "isDisabled":true,
                })
            }
            //判断最后一个时间段是否要禁用
            if((this.hold.plan[4].startTime === "" || this.hold.plan[4].startTime === null) && (this.hold.plan[4].endTime === "" || this.hold.plan[4].endTime === null)){
                this.hold.plan[5].isDisabled = true
            }else{
                this.hold.plan[5].isDisabled = false
            }
        },
        //hold模式点击全选
        changeHoldAll(val){
            if(val){
                days.map(item => {
                    this.hold[item] = true;
                })
            }else{
                days.map(item => {
                    this.hold[item] = false;
                })
                this.initAutoOpenTime();
            }
        },
        changeHoldItem(){
            let checkedItemLength = 0;
            days.map(item => {
                if(this.hold[item] === true){
                    checkedItemLength++
                }
            })
            if(checkedItemLength === 7){
                this.hold.all = true;
            }else{
                this.hold.all = false;
            }
        },
        //获取选择的星期
        getSelectDaysFun(){
            let selDaysStrArr = [];
            let selDaysArr = [];
            days.map(item => {
                if(this[this.unlockMode][item] === true){
                    selDaysStrArr.push(item)
                }
            })
            if(selDaysStrArr.length === 0){
                this.$message.info(this.$t('PleaseDaySelection'));
                return false
            }
            daysToVal.map((item,index) => {
                selDaysStrArr.map(item2 => {
                    if(item === item2){
                        selDaysArr.push(index);
                    }
                })
            })
            return selDaysArr
        },
        //apply Auto Open Time
        applyUpdatePanelsAutoOpen(){
            //获取选择的日期
            let getSelectDays = this.getSelectDaysFun();
            if(!getSelectDays){
                return false
            }
            let autoOpenObj = {};
            autoOpenObj[this.lock] = {};
            autoOpenObj[this.lock][this.unlockMode] = {};
            let getPlanArr = [];
            if(this.unlockMode === "momentory"){
                getPlanArr = this.momentory.plan.filter(item => {
                    return item.time != "" && item.time != null
                })
                //如果没有选中plan则认为是删除当前选中的星期下的plan
                if(getPlanArr.length === 0){
                    getSelectDays.map(item => {
                        if(item in autoOpenTimeData[this.lock][this.unlockMode]){
                            delete autoOpenTimeData[this.lock][this.unlockMode][item]
                        }
                    })
                }else{
                    //如果有选中plan则把选中国的plan添加到对应的lock,mode,day中
                    getSelectDays.map(item => {
                        autoOpenObj[this.lock][this.unlockMode][item] = [];
                        getPlanArr.map(p => {
                            autoOpenObj[this.lock][this.unlockMode][item].push(p.time);
                        })
                    })
                }
            }else{
                let isTimePeriodValid = false;
                for(let i = 0;i < this.hold.plan.length; i++){
                    isTimePeriodValid = this.checkTimePeriod(this.hold.plan[i].startTime,this.hold.plan[i].endTime);
                }
                if(!isTimePeriodValid){
                    return false
                }
                getPlanArr = this.hold.plan.filter(item => {
                    return item.startTime != "" && item.startTime != null  && item.endTime != "" && item.endTime != null
                })
                 //如果没有选中plan则认为是删除当前选中的星期下的plan
                if(getPlanArr.length === 0){
                    getSelectDays.map(item => {
                        if(item in autoOpenTimeData[this.lock][this.unlockMode]){
                            delete autoOpenTimeData[this.lock][this.unlockMode][item]
                        }
                    })
                }else{
                    //如果有选中plan则把选中国的plan添加到对应的lock,mode,day中
                    getSelectDays.map(item => {
                        autoOpenObj[this.lock][this.unlockMode][item] = [];
                        getPlanArr.map(p => {
                            autoOpenObj[this.lock][this.unlockMode][item].push(p.startTime + '-' + p.endTime);
                        })
                    })
                }
                
            }
            // console.log('autoOpenObj[this.lock][this.unlockMode]',autoOpenObj[this.lock][this.unlockMode]);
            // console.log('autoOpenTimeData[this.lock][this.unlockMode]',autoOpenTimeData[this.lock][this.unlockMode]);

            //使用当前选择的lock,model的plan去和之前的合并
            let finalModeObj = Object.assign({}, autoOpenTimeData[this.lock][this.unlockMode], autoOpenObj[this.lock][this.unlockMode])
            // console.log('finalModeObj',finalModeObj);
            autoOpenTimeData[this.lock][this.unlockMode] = finalModeObj;
            // console.log('fffffffffffffffinautoOpenObj222',autoOpenTimeData[this.lock][this.unlockMode]);
            //console.log('fffffffffffffffinautoOpenObj333',JSON.stringify(autoOpenTimeData[this.lock][this.unlockMode]) === '{}');
            // console.log('fffffffffffffffinautoOpenObj333',Object.keys(autoOpenTimeData[this.lock][this.unlockMode]).length === 0);
            // if(Object.keys(autoOpenTimeData[this.lock][this.unlockMode]).length === 0){
            //     autoOpenTimeData[this.lock][this.unlockMode] = null;
            // }
            // console.log('fffffffffffffffinautoOpenObj444',autoOpenTimeData);

            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            }
            let generalConfigObj = {
                "entranceDeviceId": this.updatePanels.id,
                "siteId":this.selectSite.id,
                "autoUnlockTimes":JSON.stringify(autoOpenTimeData),
            };
            // return false
            this.generalSettings.updateAutoOpenState = 1;
            sitesPanelsApi.saveGeneralDeviceShadowConfig(rgnObj,generalConfigObj).then(res => {
                if(res.code === 0){
                    this.$message.success(this.$t('ApplicationSuccessful'));
                    this.generalSettings.updateAutoOpenState = 0;
                    //获取Auto Open Time Settings 配置
                    this.getGeneralShadowConfig();
                }else{
                    this.generalSettings.updateAutoOpenState = 0;
                    this.$handerrcode(res.code);
                    //获取Auto Open Time Settings 配置
                    this.getGeneralShadowConfig();
                }
            }).catch((err) => {
                console.log(err);
                this.generalSettings.updateAutoOpenState = 0;
            })
        }
    },
    
}
</script>

<style scoped>
.autoOpenTop{
    text-align: left;
}
.panelsItem{
    display: flex;
    align-items: baseline;
    margin-top: 10px;
}
.panelsItem label{
    width: 135px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.panelsItem input{
    width: 300px;
}
.autoOpenCenter{
    padding: 5px 25px 20px;
    width: 320px;
    margin-top: 20px;
    background: #F4F4F4;
    border-radius: 8px;
}
.autoOpenCenter .panelsItem{
    margin-top: 0;
}
.editInput{
    width: 12vw;
    min-width: 170px;
}
::v-deep .editInput .el-input__inner {
    height: 39px!important;
    line-height: 39px!important;
    border: 1px solid #333;
    background: #fff;
}
.panelsItem label{
    width: 135px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.panelsItem input{
    width: 300px;
}
::v-deep .editInput .el-input__inner:hover {
    height: 39px!important;
    line-height: 39px!important;
    border: 1px solid #333;
    background: #fff;
}
::v-deep .timePicker .el-input__inner{
    height: 35px;
    line-height: 35px;
    background: #fff;
    text-align: center;
}
::v-deep .autoOpenCenter .panelsItem .el-input__icon{
    line-height: 35px;
    /* display: none; */
}
/* ::v-deep .timePicker input::placeholder{
   font-size: 12px !important;
} */
/* input::placeholder {
  font-size: 14px;
  color: #999;
} */
.autoOpenFoot{
    padding: 5px 25px 20px;
    width: 320px;
    margin-top: 20px;
    background: #F4F4F4;
    border-radius: 8px;
}
.autoOpenFoot h5{
    text-align: left;
    margin-top: 5px;
}
.dayAll{
    text-align: left;
    margin-top: 10px;
}
.dayItemBox{
    text-align: left;
    margin-top: 10px;
}
.dayItem{
    float: left;
    width: 80px;
}
.dayItemBox::after {
    content: "";
    display: block;
    clear:both;
}

.bottomDiv{
    position: fixed;
    bottom: 38px; 
    width:100%
}
.savetBtn{
    background: #6498b5;
    color: #fff;
    font-weight: bold;
    width: 220px;
    height: 36px;
    padding: 6px 20px;
}
</style>